import React from "react";
import {Button, Checkbox, Drawer, Form, Input, InputNumber, message,} from "antd";
import {BusinessCategory} from "../../../../../filters/BusinessCategory";
import {BillToGet, BillToPost, BillToUpdate} from "../../../../../models/billto";
import {PaymentMethod} from "../../../../../filters/PaymentMethod";

const FormItem = Form.Item;
const { TextArea } = Input;

class EditBillToDataForm extends React.Component {
  state = {};

  handlePopupAfterAddUpdate = () => {
    this.props.setModelVisible()
    this.props.fetch();
  };

  handleDrawerSubmit = (e) => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (!this.props.row_id) {
          BillToPost(values)
            .then(response => {
              message.success('Bill To Create Successfully');
              this.handlePopupAfterAddUpdate();
            })
        }
        else {
          BillToUpdate(this.props.row_id, values)
            .then(response => {
              message.success('Bill To Updated Successfully');
              this.handlePopupAfterAddUpdate()
            });
        }
      }
    });
  };
  fetchBillTo = (id) => {
    let form = this.props.form;
    BillToGet(id)
      .then(response => {
        form.setFieldsValue({
          email: response.data.email,
          company_name: response.data.company_name,
          address: response.data.address,
          city: response.data.city,
          state: response.data.state,
          zip_code: response.data.zip_code,
          phone: response.data.phone,
          contact: response.data.contact,
          notes: response.data.notes,
          po: response.data.po,
          payment_status: response.data.payment_status,
        });
        response.data.payment_term &&
        this.payment_term.handleChange({
          key: response.data.payment_term.id,
          label: response.data.payment_term.name
        })
      })
  };

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)
  }

  componentDidUpdate(prevProps) {
    const { visible, row_id } = this.props;
    if (visible && row_id && (visible !== prevProps.visible && row_id !== prevProps.row_id))
      this.fetchBillTo(row_id)
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const { fields } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <Drawer title={this.props.row_id ? "Update Bill To" : "Create Bill To"} placement="right"
        onClose={() => this.props.setModelVisible()} visible={this.props.visible} className="floating-form"
        destroyOnClose={true}>
        <Form>
          <FormItem label="Email">
            {getFieldDecorator('email', {
              rules: [{
                type: 'email', message: 'The input is not valid E-mail!',
              }, {
                required: true, message: 'Please input your E-mail!',
              }],
            })(
              <Input placeholder="Enter email" />
            )}
          </FormItem>
          <FormItem label="Company Name">
            {getFieldDecorator('company_name', {
              rules: [{ required: true, message: 'Please input company name' }],
            })(<Input placeholder="Enter company name" />)}
          </FormItem>
          <FormItem label="Address">
            {getFieldDecorator('address', {
              rules: [{ required: true, message: 'Please input address' }],
            })(
              <Input placeholder="Enter address" />
            )}
          </FormItem>
          <FormItem label="City">
            {getFieldDecorator('city', {
              rules: [{ required: true, message: 'Please input city' }],
            })(
              <Input placeholder="Enter city" />
            )}
          </FormItem>
          <FormItem label="State">
            {getFieldDecorator('state', {
              rules: [{ required: true, message: 'Please input state' }],
            })(
              <Input placeholder="Enter state" />
            )}
          </FormItem>
          <FormItem label="Zip Code">
            {getFieldDecorator('zip_code', {
              rules: [{ required: true, message: 'Please input zip code' }],
            })(
              <Input placeholder="Enter zip code" />
            )}
          </FormItem>
          <FormItem label="Phone">
            {getFieldDecorator('phone', {
              rules: [{ required: true, message: 'Please input phone' }],
            })(
              <Input placeholder="Enter phone" />
            )}
          </FormItem>
          <FormItem label="Contact">
            {getFieldDecorator('contact', {
              rules: [{ required: true, message: 'Please input contact' }],
            })(
              <Input placeholder="Enter contact" />
            )}
          </FormItem>
          <FormItem label="Payment Term">
            {getFieldDecorator('payment_term', {
              rules: [{required: true, message: 'Please select payment term'}],
            })(<PaymentMethod onRef={ref => (this.payment_term = ref)} {...fields} />)}
          </FormItem>
          <FormItem label="Payment Status" className="payment-status" >
            {getFieldDecorator('payment_status', {valuePropName: 'checked'})(<Checkbox>Check if On Hold</Checkbox>)}
              </FormItem>
          <FormItem label="Notes">
            {getFieldDecorator('notes', {
              rules: [{ required: true, message: 'Please input notes' }],
            })(
              <TextArea placeholder="Enter notes" autosize={{ minRows: 4 }} />
            )}
          </FormItem>
          <Button type="primary" htmlType="button"
            onClick={this.handleDrawerSubmit}>{this.props.row_id ? "Update Bill To" : "Create Bill To"}</Button>
        </Form>
      </Drawer>
    )
  }
}

export const EditBillToData = Form.create()(EditBillToDataForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/data_management/bill_to/popups/EditBillToData.jsx